// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Ub11","insightsList":"newBusinessInsightsMenu_insightsList__2DuTu","active":"newBusinessInsightsMenu_active__1ZmIg"};